import { useQuery } from '@tanstack/react-query';
import type { AgentApiCustomCategoriesIndex } from '@/types/serializers';

type CustomizeType = 'candidate_profile' | 'company' | 'candidate_interview_log';

const RECORD_CLASS_NAME_MAP = {
  candidate_profile: 'CandidateProfile',
  company: 'Company',
  candidate_interview_log: 'CandidateInterviewLog',
} as const;

export interface CustomCategory {
  id: number;
  name: string;
  orderNumber: number;
  recordClassName: string;
}

export default function useFetchCustomCategories(type: CustomizeType) {
  return useQuery({
    queryKey: ['custom_categories', type],
    queryFn: async () => {
      const params = new URLSearchParams({
        record_class_name: RECORD_CLASS_NAME_MAP[type],
      });
      const response = await fetch(`/agent/api/custom_categories?${params}`);
      if (!response.ok) {
        throw new Error('Failed to fetch custom categories');
      }
      const data: AgentApiCustomCategoriesIndex = await response.json();
      return data.records.map((record) => ({
        id: record.id,
        name: record.name,
        orderNumber: record.order_number,
        recordClassName: record.record_class_name,
      })) as CustomCategory[];
    },
  });
}
